import React, {Component} from 'react';
import {TopButtonAction} from "../../../../../../componentsTopsa/buttons/TopButtons";
import {BootstrapTable, TableHeaderColumn} from "react-bootstrap-table";
import tabgrid from "../../../../../../utilities/TabGrid";
import TopIf from "../../../../../../componentsTopsa/if/TopIf";
import ObsadaService from "../../../obsada/ObsadaService";
import RozkladService from "../../../rozklad/RozkladService";

export default class SprawdzKonfiguraceTable extends Component {
    constructor(props) {
        super(props);
        this.state = {
            pokazModal: false,
            ladowanieModala: false,
            modalNaglowek: '',
            modalDane: []
        };
        this.formatDaneCzyKal = this.formatDaneCzyKal.bind(this)
        this.formatDaneCzyKalGodz = this.formatDaneCzyKalGodz.bind(this)
        this.formatDaneCzyRozklad = this.formatDaneCzyRozklad.bind(this)
        this.formatDaneCzyObsada = this.formatDaneCzyObsada.bind(this)
        this.formatDaneCzyReczneKursy = this.formatDaneCzyReczneKursy.bind(this)
        this.formatDaneIloscKursow = this.formatDaneIloscKursow.bind(this)
    }

    czyMinelaJuzData(data){
        let now = new Date().toJSON().substr(0,10)
        return(now>data)
    }

    onClickPokazGodzinyOdjazdow(obj) {
        if (Boolean(this.props.idTr)) {
            this.setState({ladowanieModala: true, modalNaglowek: 'Godziny odjazdów dla dnia ' + obj.data + ':'})
            ObsadaService.sprawdzDokladnaKonfiguracje(obj.data, this.props.idTr, 0).then(function (response) {
                this.setState({pokazModal: true, modalDane: response.data, ladowanieModala: false})
            }.bind(this))
        }
    }

    onClickPokazNiewygenerowaneKursy(obj) {
        if (Boolean(this.props.idTr)) {
            this.setState({ladowanieModala: true, modalNaglowek: 'Nie wygenerowano kursów dla następujących godzin w dniu ' + obj.data + ':'})
            ObsadaService.sprawdzDokladnaKonfiguracje(obj.data, this.props.idTr, 1).then(function (response) {
                this.setState({pokazModal: true, modalDane: response.data, ladowanieModala: false})
            }.bind(this))
        }
    }

    onClickPokazNieobsadzoneKursy(obj) {
        if (Boolean(this.props.idTr)) {
            this.setState({ladowanieModala: true, modalNaglowek: 'Nie obsadzono następujących kursów w dniu ' + obj.data + ':'})
            ObsadaService.sprawdzDokladnaKonfiguracje(obj.data, this.props.idTr, 2).then(function (response) {
                this.setState({pokazModal: true, modalDane: response.data, ladowanieModala: false})
            }.bind(this))
        }
    }

    onClickPokazRecznieDodane(obj) {
        if (Boolean(this.props.idTr)) {
            this.setState({ladowanieModala: true, modalNaglowek: 'Dodano ręcznie kursy na  następujące godziny w dniu ' + obj.data + ':'})
            ObsadaService.sprawdzDokladnaKonfiguracje(obj.data, this.props.idTr, 3).then(function (response) {
                this.setState({pokazModal: true, modalDane: response.data, ladowanieModala: false})
            }.bind(this))
        }
    }

    onClickPokazWszytskieKursy(obj) {
        if (Boolean(this.props.idTr)) {
            this.setState({ladowanieModala: true, modalNaglowek: 'Wszystkie kursy w dniu ' + obj.data + ':'})
            RozkladService.getSzukajRozkladPierwszePrzystanki(0, 999999, 'data=' + obj.data + '&idTr=' + this.props.idTr).then(function (response) {
                this.setState({pokazModal: true, modalDane: response.data.content, ladowanieModala: false})
            }.bind(this))
        }
    }

    formatDaneCzyKal(cell, row) {
        if (cell === 1) {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak</div>)
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie</div>)
        }
    }

    formatDaneCzyKalGodz(cell, row) {
            if (cell === 1) {
                return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak <a
                    onClick={() => {
                        this.onClickPokazGodzinyOdjazdow(row)
                    }}
                    style={{cursor: 'pointer'}}
                    className={'przyciskPokazSzczegolySprawdzenieKonfiguracji'}
                ><i className={'fa fa-eye'}></i> Pokaż</a></div>)
            }
            else {
                return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie</div>)
            }

    }

    formatDaneCzyRozklad(cell, row) {

        if (row.l_kursow === 0) {
            return <div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> brak kursów</div>
        }
        if (cell === 1) {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak</div>)
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie <a
                onClick={() => {
                    this.onClickPokazNiewygenerowaneKursy(row)
                }}
                style={{cursor: 'pointer'}}
                className={'przyciskPokazSzczegolySprawdzenieKonfiguracji'}
            ><i className={'fa fa-eye'}></i> Pokaż brakujące</a>
            </div>)
        }
    }

    formatDaneCzyReczneKursy(cell, row) {

        if (cell === 1) {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak <a
                onClick={() => {
                    this.onClickPokazRecznieDodane(row)
                }}
                style={{cursor: 'pointer'}}
                className={'przyciskPokazSzczegolySprawdzenieKonfiguracji'}
            ><i className={'fa fa-eye'}></i> Pokaż</a>
            </div>)
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie</div>)
        }
    }

    formatDaneIloscKursow(cell, row) {

        if (cell === 0) {
            return <span style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}>{cell}</span>
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}>{cell} <a
                onClick={() => {
                    this.onClickPokazWszytskieKursy(row)
                }}
                style={{cursor: 'pointer'}}
                className={'przyciskPokazSzczegolySprawdzenieKonfiguracji'}
            ><i className={'fa fa-eye'}></i> Pokaż</a>
            </div>)
        }
    }

    formatDaneCzyObsada(cell, row) {

        if (row.l_kursow === 0) {
            return <div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> brak kursów</div>
        }
        if (cell === 1) {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'forestgreen'}} className={'fa fa-check'}></i> tak</div>)
        }
        else {
            return (<div style={(this.czyMinelaJuzData(row.data))?{opacity:'0.6'}:{}}><i style={{color: 'firebrick'}} className={'fa fa-times'}></i> nie <a
                onClick={() => {
                    this.onClickPokazNieobsadzoneKursy(row)
                }}
                style={{cursor: 'pointer'}}
                className={'przyciskPokazSzczegolySprawdzenieKonfiguracji'}
            ><i className={'fa fa-eye'}></i> Pokaż nieobsadzone</a>
            </div>)
        }
    }

    renderNazwaTrasy() {
        if (Boolean(this.props)) {
            let trasa = this.props.trasy.find(t => t.idTr == this.props.idTr)
            if (trasa) {
                return 'Trasa: ' + trasa.nazTr
            }
        }
    }

    render() {

        let statusy = {
            true: 'tak',
            false: 'nie'
        }

        return (
            <div>
                <h2 style={{textAlign: 'center', margin: '30px 0'}}>
                    {
                        Boolean(this.props.data) ?
                            Boolean(this.props.idTr) ?
                                this.renderNazwaTrasy()
                                :
                                ''
                            :
                            ''
                    }
                </h2>
                <div>
                    <BootstrapTable data={this.props.data}
                                    hover
                    >
                        <TableHeaderColumn dataField='data' isKey hidden={true}>ID</TableHeaderColumn>
                        <TableHeaderColumn dataField='data'
                                           thStyle={tabgrid.tg2} tdStyle={tabgrid.tg2} dataSort
                                           filter={(this.props.wlaczSzukanie) ? {type: 'TextFilter', delay: 500, placeholder: 'Szukaj'} : false}
                        >Data</TableHeaderColumn>
                        <TableHeaderColumn dataField='czy_kal'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDaneCzyKal}
                        >Czy wygenerowano kalendarze do daty?</TableHeaderColumn>
                        <TableHeaderColumn dataField='czy_kal_godz'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDaneCzyKalGodz}
                        >Czy istnieją godziny odjazdów?</TableHeaderColumn>
                        <TableHeaderColumn dataField='czy_rozkl'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDaneCzyRozklad}
                        >Czy wygenerowano rozkład?</TableHeaderColumn>
                        <TableHeaderColumn dataField='czy_reczne_kursy'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           dataFormat={this.formatDaneCzyReczneKursy}
                                           formatExtraData={statusy}
                        >Czy dodano ręcznie kursy?</TableHeaderColumn>
                        <TableHeaderColumn dataField='l_kursow'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                           filter={{type: 'NumberFilter', delay: 500, placeholder: 'Szukaj'}}
                                           dataFormat={this.formatDaneIloscKursow}
                        >Ilość wszystkich kursów</TableHeaderColumn>
                        <TableHeaderColumn dataField='czy_obs'
                                           thStyle={tabgrid.tg3} tdStyle={tabgrid.tg3} dataSort
                                           filter={{type: 'SelectFilter', options: statusy, selectText: 'Wybierz'}}
                                           formatExtraData={statusy}
                                           dataFormat={this.formatDaneCzyObsada}
                        >Czy wygenerowano obsadę?</TableHeaderColumn>
                    </BootstrapTable>
                </div>
                <TopIf isTrue={this.state.pokazModal}>
                    <div id={'EBUSModalContainerBG'}>
                        <div id={'modalContainer'}>
                            <div>
                                <div className={'pull-right'}>
                                    <TopButtonAction onClick={() => {
                                        this.setState({
                                            pokazModal: false,
                                            ladowanieModala: false,
                                            modalNaglowek: '',
                                            modalDane: []
                                        })
                                    }}
                                                     elementStyle={{color:'firebrick'}}
                                                     btnColor={'default'} text={'Zamknij'} iconType={'fa fa-times'}
                                    />
                                </div>
                            </div>
                            <div style={{clear: 'both'}}></div>
                            {
                                Boolean(this.state.ladowanieModala) ?
                                    <div id={'ladowanieModala'}>
                                        <i className={'fa fa-circle-o-notch fa-spin'}></i>
                                        <h6>Trwa ładowanie danych</h6>
                                    </div>
                                    :
                                    <div id={'modalTextContent'}>
                                        <h4>
                                            {this.state.modalNaglowek}
                                        </h4>
                                        <div>
                                            {
                                                this.state.modalDane.map(item => {
                                                    if ((this.state.modalNaglowek.indexOf('obsadzono') > -1))
                                                        return (
                                                            <span className={'modalPozycjaPodwojna'}>
                                                        <div className={'modalGodz'}>
                                                        {item.godz}
                                                        </div>
                                                        <div className={'modalKurs'}>
                                                            {item.id_ku}
                                                        </div>
                                                        </span>
                                                        )
                                                    else if (this.state.modalNaglowek.indexOf('Wszystkie kursy') > -1)
                                                        return (
                                                            <span className={'modalPozycjaPodwojna'}>
                                                        <div className={'modalGodz'}>
                                                        {item.godz}
                                                        </div>
                                                        <div className={'modalKurs'}>
                                                            {item.idKu}
                                                        </div>
                                                        </span>
                                                        )
                                                    else
                                                        return <span className={'modalPozycjaPojedyncza'}>{item.godz}</span>
                                                })
                                            }
                                        </div>
                                    </div>

                            }

                        </div>
                    </div>
                </TopIf>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/konfiguracja/rozkladConfig/sprawdzKonfiguracje/components/componentsRozklad/SprawdzKonfiguraceTable.js